export default __webpack_public_path__ + "static/media/Number_3.2a14c7e6.svg";